import { compose, keys, prop, values } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getRoot = (state) => state[NAME];

const getTaskObject = compose(prop('tasks'), getRoot);

export const getTasks = compose(values, getTaskObject);

export const getTaskIds = createSelector(getTaskObject, keys);

export const getTaskById = (id, state) => getTaskObject(state)[id];
